// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AccessTokensQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type AccessTokensQuery = {
  __typename?: "GraphqlQuery";
  getAccessTokens: Array<{
    __typename?: "AccessToken";
    id: string;
    name: string;
    tokenPrefix: string;
    scopes: Array<string>;
    expiresAt?: number | null;
    expired: boolean;
    lastUsedAt?: number | null;
    createdAt: number;
  }>;
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    accessTokenScopes: Array<{
      __typename?: "TokenScope";
      name: string;
      label: string;
      required: boolean;
    }>;
  } | null;
};

export const AccessTokensDocument = gql`
  query AccessTokens($organizationSlug: ID!) {
    getAccessTokens(organizationSlug: $organizationSlug) {
      id
      name
      tokenPrefix
      scopes
      expiresAt
      expired
      lastUsedAt
      createdAt
    }
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      accessTokenScopes {
        name
        label
        required
      }
    }
  }
`;

/**
 * __useAccessTokensQuery__
 *
 * To run a query within a React component, call `useAccessTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessTokensQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useAccessTokensQuery(
  baseOptions: Apollo.QueryHookOptions<
    AccessTokensQuery,
    AccessTokensQueryVariables
  > &
    (
      | { variables: AccessTokensQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccessTokensQuery, AccessTokensQueryVariables>(
    AccessTokensDocument,
    options,
  );
}
export function useAccessTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccessTokensQuery,
    AccessTokensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccessTokensQuery, AccessTokensQueryVariables>(
    AccessTokensDocument,
    options,
  );
}
// @ts-ignore
export function useAccessTokensSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccessTokensQuery,
    AccessTokensQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AccessTokensQuery, AccessTokensQueryVariables>;
export function useAccessTokensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccessTokensQuery,
        AccessTokensQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccessTokensQuery | undefined,
  AccessTokensQueryVariables
>;
export function useAccessTokensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccessTokensQuery,
        AccessTokensQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AccessTokensQuery, AccessTokensQueryVariables>(
    AccessTokensDocument,
    options,
  );
}
export type AccessTokensQueryHookResult = ReturnType<
  typeof useAccessTokensQuery
>;
export type AccessTokensLazyQueryHookResult = ReturnType<
  typeof useAccessTokensLazyQuery
>;
export type AccessTokensSuspenseQueryHookResult = ReturnType<
  typeof useAccessTokensSuspenseQuery
>;
export type AccessTokensQueryResult = Apollo.QueryResult<
  AccessTokensQuery,
  AccessTokensQueryVariables
>;
